import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { AppThunk } from 'store/types';
import { IParamsReq } from 'types';
import { IAnalyticsRating } from 'features/Analytics/AnalyticsRating/types';

import { downloadFileByGet } from 'helpers';

interface IAnalyticsRatingStore {
  loading: boolean;
  data: IAnalyticsRating | null;
}

const initialState: IAnalyticsRatingStore = {
  loading: false,
  data: null,
};

const reset: CaseReducer<IAnalyticsRatingStore> = () => initialState;

const loading: CaseReducer<IAnalyticsRatingStore, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

const data: CaseReducer<IAnalyticsRatingStore, PayloadAction<IAnalyticsRating>> = (
  state,
  action,
) => {
  state.data = action.payload;
};

export const analyticsRatingSlice = createSlice({
  name: 'analyticsRating',
  initialState,
  reducers: {
    reset,
    loading,
    data,
  },
});

const { reset: setReset, loading: setLoading, data: setData } = analyticsRatingSlice.actions;

export const getAnalyticsRating =
  (params: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<IAnalyticsRating>('/api/analytics/applicant-rating/', params)
      .then(({ data }) => {
        dispatch(setData(data));
      })
      .then(() => dispatch(setLoading(false)));
  };

export const getDownloadExcel = async (params: IParamsReq) => {
  await downloadFileByGet({
    url: '/api/analytics/generate-report-applicant-rating/',
    params,
  });
};

export { setReset };
